<h3 class="session-modal-title">
  <span>{{'sessionExpirationDialog.header' | translate}}</span>
</h3>
<div class="session-modal-content">
  <p>{{'sessionExpirationDialog.content' | translate}}</p>
  <div class="buttons-bar" style=" margin-top: 3rem !important;">
    <button (click)="close()" mat-button class="btn-primary" type="button">{{'common.buttons.close' | translate | titlecase}}</button>
  </div>
</div>